'use client';

import type { CheckBoxListGlobalFilterItem, SearchListResponse } from '@weberus/shared-types';
import { useMemo, useState } from 'react';
import { Checkbox, SubHeader } from '@yanolja-rnd/nol-design-system';
import { MoreButton } from './item/more-button';

/** (기본) 최대 6개 노출 */
const MAX_ITEM_COUNT = 6;

interface CheckboxTypeFilterProps extends CheckBoxListGlobalFilterItem {
  onClick: (idx: number) => void;
  onMoreButtonClick: (logMeta: SearchListResponse['serverLogMeta']) => void;
}

export const CheckboxTypeFilter: React.FC<CheckboxTypeFilterProps> = ({
  title,
  items,
  serverLogMeta,
  onClick,
  onMoreButtonClick,
}) => {
  const [isFold, setIsFold] = useState(true); // 기본 접혀있는 상태
  const hasSelectedItems = items.some((item) => item.selected);

  const renderItems = useMemo(() => (isFold ? items.slice(0, MAX_ITEM_COUNT) : items), [isFold, items]);
  const hasMoreItems = items.length > MAX_ITEM_COUNT;

  return (
    <section className="px-16 pb-32 pt-16">
      <SubHeader.Small title={title} showDotBadge={hasSelectedItems} />
      <div className="grid gap-x-20 legacy-pc:grid-cols-2">
        {renderItems.map((item, idx) => (
          <div
            key={idx}
            className="flex h-44 items-center justify-between legacy-pc:flex-row-reverse legacy-pc:gap-x-8">
            <label
              className="w-full cursor-pointer text-text-neutral-main typography-body-14-regular"
              htmlFor={`${item.key}_${item.code}_selected`}>
              {item.title}
            </label>
            <Checkbox
              id={`${item.key}_${item.code}_selected`}
              checked={item.selected}
              size="medium"
              onChange={() => {
                onClick(idx);
              }}
            />
          </div>
        ))}
      </div>
      {/* 6개를 초과하는 경우 더보기/접기 버튼 노출 */}
      {!!hasMoreItems && (
        <MoreButton
          isFold={isFold}
          setIsFold={setIsFold}
          onClick={() => {
            onMoreButtonClick(serverLogMeta);
          }}
        />
      )}
    </section>
  );
};
